import type { ReportPlayStatus } from "@meta-video/contracts";

export const playStatusLabels: Readonly<Record<ReportPlayStatus, string>> = {
  hosted: "Playable",
  not_tracked: "Not tracked",
  pending: "Pending",
  unavailable: "Unavailable",
};
